import { translateFilterOptionLabel } from "./translate-utils";

export const PRIORITY_LEVELS = {
	VERY_URGENT: "VERY_URGENT",
	URGENT: "URGENT",
	NORMAL: "NORMAL",
	LOW: "LOW",
};

export const getPriorityConfig = (priority) => {
	if (priority === PRIORITY_LEVELS.VERY_URGENT) {
		return {
			color: "error",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.VERY_URGENT,
		};
	}
	if (priority === PRIORITY_LEVELS.URGENT) {
		return {
			color: "warning",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.URGENT,
		};
	}
	if (priority === PRIORITY_LEVELS.NORMAL) {
		return {
			color: "success",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.NORMAL,
		};
	}
	if (priority === PRIORITY_LEVELS.LOW) {
		return {
			color: "neutral",
			label: translateFilterOptionLabel("priority", priority),
			level: PRIORITY_LEVELS.LOW,
		};
	}
	return {
		color: "neutral",
		label: priority || "-",
		level: PRIORITY_LEVELS.LOW,
	};
};
